import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { makeRequest } from "../apis/makeRequest";
import { getProducts } from "../apis/backendRequests";
import ProductCardCatalogo from "../components/Catalogo/ProductCardCatalogo";
import { Grid, useMediaQuery } from "@mui/material";
import Carrousel from "../components/Carrousel";
import { useTheme } from "@emotion/react";

const size = (l) => {
  switch (l) {
    case 1:
      return 13;
    case 2:
      return 5;
    case 3:
      return 4;
    default:
      return 3;
  }
};

export default function Catalogo({ inicio = false }) {
  const { searchTerm, categoria, rubro, subRubro, promocion } = useSelector(
    (state) => state.gallery
  );
  const { items } = useSelector((state) => state.cart);
  const { isLoggedIn } = useSelector((state) => state.account);

  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const lastItemRef = useRef()
  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down("md"))

  useEffect(() => {
    setPage(1);
  }, [searchTerm, categoria, rubro, subRubro, promocion]);

  useEffect(() => {

    localStorage.setItem("cartItems", JSON.stringify(items));
    localStorage.setItem("orderItems", []);
  }, [items]);

  useEffect(() => {
    let rowsPerPage = inicio ? (mobile ? 10 : 20) : 10
    makeRequest(
      () =>
        getProducts(
          "online",
          1,
          inicio ? rowsPerPage : rowsPerPage * page,
          inicio ? '' : searchTerm,
          inicio ? '' : categoria,
          inicio ? '' : rubro,
          inicio ? '' : subRubro,
          inicio ? 'Destacados' : promocion
        ),
      (res) => setProducts(res.data)
    );
  }, [searchTerm, categoria, rubro, subRubro, page, promocion]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && entries[0].time > 2000) {
          setPage(page + 1);
        }
      },
      { threshold: 0.9 }
    );

    const current = lastItemRef.current;

    if (current) observer.observe(current);

    return () => observer.disconnect(current);
  });


  const productGrid = products.map((product, i) => {
    return (
      <Grid
        item
        padding={0}
        md={inicio ? 11 : size(products.length)}
        sx={mobile ? { width: "100vw" } : inicio ? { width: "20vw", height: "400px" } : { width: "20vw" }}
        key={product.productId}
        ref={i === 10 * page - 1 ? lastItemRef : null}
      >
        <ProductCardCatalogo product={product} index={i} isClient={isLoggedIn} />
      </Grid>
    );
  });



  return (
    <div>
      <Grid spacing={2} container sx={inicio ? { display: "flex" } : { display: "flex" }}>
        {inicio ? <Carrousel image={productGrid} productsLanzamiento /> : productGrid}
      </Grid>
    </div>
  );
}
